import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeX = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 3,
		d: "M22.525 29 3 3h6.475L29 29h-6.475Zm5.557-26L17.789 14.075M3.918 29l10.285-11.067"
	})
});
export default SvgKgCardTypeX;
